<template>
  <div class="tree animate__animated animate__fadeInDown custom-scroll elt">
    <ul>
      <li>
        <router-link to="/app/tools">
          <i class="fa fa-folder-open"></i> Tools
        </router-link>
        <ul v-if="folders">
          <li v-for="(folder, index) in folders" :key="index" @click="setCurrentFolder(folder)" class="elt-text">

            <i :class="currentFolder.name === folder.name ? 'fa fa-folder-open' : 'fa fa-folder'"></i> {{ folder.name }}
            <ul v-if="currentFolder.name === folder.name">
              <li v-for="file in files" :key="file.id"><i class="fa fa-file"></i> {{ file.name }}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  import globalMixins from '@/utils/mixins/mixin.js'

  export default {
    mixins: [globalMixins],
    name: 'Tree',
    props: {
      folders: {
        type: Array,
        default: null,
        required: true
      },
      currentFolder: {
        type: Array,
        default: null,
        required: true
      },
      currentFile: {
        type: Array,
        default: null,
        required: true
      }
    },

    data () {
      return {

      }
    },

    mounted () {

    },

    methods: {

    }
  }
</script>

<style scoped lang="scss">
  $color: #007bff;

  .tree {
    position: fixed;
    background: #eee;
    right: 1vw;
    top: 18vh;
    border: solid $color 1px;
    padding: 30px 10px;
    font-size: .78rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    width: 15vw;
    height: 30vh;
    overflow-x: hidden;
    overflow-y: scroll;
    z-index: 0;

    &::-webkit-scrollbar-thumb { border-radius: none !important; }

    span {
      font-size: 13px;
      font-style: italic;
      letter-spacing: .4px;
      color: #a8a8a8;
    }

    .fa-folder-open, .fa-folder {
      color: #007bff;
    }

    .fa-file {
      color: $color;
    }

    ul {
      padding-left: 5px;
      list-style: none;

      li {
        position: relative;
        padding-top: 5px;
        padding-bottom: 5px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-left: 15px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;

        &:before {
          position: absolute;
          top: 15px;
          left: 0;
          width: 10px;
          height: 1px;
          margin: auto;
          content: '';
          background-color: #666;
        }

        &:after {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          width: 1px;
          height: 100%;
          content: '';
          background-color: #666;
        }

        &:last-child:after {
          height: 15px;
        }
      }

      .elt-text:hover {
        color: #111;
      }

      a {
        cursor: pointer;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
</style>
